import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CircleQuestionMark, ChevronDown, LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'app-accordion',
    standalone: true,
    imports: [LucideAngularModule, NgClass],
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
    @Input({ required: true }) items: { title: string; content: string }[] = [];
    @Input() openAllOnInit: boolean = false;

    openIndexes: Set<number> = new Set();

    readonly CircleQuestionMark = CircleQuestionMark;
    readonly ChevronDown = ChevronDown;

    ngOnInit() {
        if (this.openAllOnInit) {
            this.openIndexes = new Set(this.items.map((_, i) => i));
        }

        this.items = [];
    }

    toggle(idx: number) {
        if (this.openIndexes.has(idx)) {
            this.openIndexes.delete(idx);
        } else {
            this.openIndexes.add(idx);
        }
        // For Angular's change detection
        this.openIndexes = new Set(this.openIndexes);
    }

    isOpen(idx: number): boolean {
        return this.openIndexes.has(idx);
    }
}
